/**
 * « Aide & idées » — customer feedback from the vanilla editors to Google Chat.
 * Keep the payload rules in sync with src/shared/helpFeedback.ts.
 */
(function () {
  if (window.SherpaHelpFeedback) return;

  var WEBHOOK_URL =
    "https://chat.googleapis.com/v1/spaces/AAQA6GpEFdE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=dRt3bxJ0ieV7f9Aw_Y5xHnm0dhp2KE7r7uV3kTL0XHU";
  var CHAT_TEXT_LIMIT = 4096;
  var TRUNCATION_MARKER = "\n… [message tronqué — trop long pour Google Chat]";
  var MAX_FILE_BYTES = 8 * 1024 * 1024;
  var FILE_ACCEPT =
    ".pdf,.png,.jpg,.jpeg,.webp,.svg,.ai,.eps,.zip,application/pdf,image/png,image/jpeg,image/webp,image/svg+xml,application/postscript,application/zip";
  var FILE_EXTENSIONS = /\.(pdf|png|jpe?g|webp|svg|ai|eps|zip)$/i;
  var COMMENT_MAX_LENGTH = 2000;

  var EDITOR_LABELS = {
    "select-3d": "Éditeur écussons",
    "lettres-numeros": "Éditeur lettres & numéros",
    "creation-masse": "Éditeur création en masse",
    amalgame: "Éditeur d'amalgame",
    bat: "Éditeur de BAT",
    logo: "Éditeur de logo",
    "logo-quality": "Vérificateur de logo",
  };

  var MARKDOWN_SUBSTITUTIONS = [
    [/\*/g, "\u2217"],
    [/_/g, "\u02cd"],
    [/~/g, "\u223c"],
    [/`/g, "\u02cb"],
    [/</g, "\u2039"],
    [/>/g, "\u203a"],
  ];

  function sanitizeFeedbackText(raw) {
    var text = String(raw == null ? "" : raw).replace(/\r\n?/g, "\n");
    text = text.replace(/[\u2028\u2029\u0085]/g, "\n");
    text = text.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, " ");
    text = text.replace(/[\u200b-\u200f\u202a-\u202e\u2060\u2066-\u2069\ufeff]/g, "");
    for (var i = 0; i < MARKDOWN_SUBSTITUTIONS.length; i += 1) {
      text = text.replace(MARKDOWN_SUBSTITUTIONS[i][0], MARKDOWN_SUBSTITUTIONS[i][1]);
    }
    return text.replace(/[ \t]+$/gm, "").replace(/\n{3,}/g, "\n\n").trim();
  }

  function isValidFeedbackEmail(email) {
    var value = String(email == null ? "" : email).trim();
    if (!value || value.length > 254) return false;
    return /^[^\s@<>,;"]+@[^\s@<>,;".]+\.[a-z]{2,}$/i.test(value);
  }

  function validateFeedbackFile(file) {
    var megabytes = Math.round(MAX_FILE_BYTES / (1024 * 1024));
    if (!file) return null;
    if (file.size > MAX_FILE_BYTES) {
      return "Fichier trop lourd (max " + megabytes + " Mo). Compressez-le puis réessayez.";
    }
    if (!file.size) return "Fichier vide — vérifiez votre sélection.";
    if (!FILE_EXTENSIONS.test(file.name || "")) {
      return "Format non accepté. Joignez un PDF, PNG, JPG, WEBP, SVG, AI, EPS ou ZIP.";
    }
    return null;
  }

  function chatLink(url, label) {
    var safeUrl = String(url == null ? "" : url).trim();
    var safeLabel = sanitizeFeedbackText(label) || "ouvrir";
    if (!/^https?:\/\/[^\s<>|]+$/i.test(safeUrl)) return safeLabel;
    return "<" + safeUrl + "|" + safeLabel + ">";
  }

  function productHandleFromLocation(url) {
    try {
      var path = String(url || window.location.pathname)
        .split("?")[0]
        .split("#")[0];
      var match = path.match(/\/(?:products|pages)\/([^/]+)/i);
      return match && match[1] ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      return "";
    }
  }

  function productTypeLine(context) {
    if (context.productType) return String(context.productType);
    var summary = sanitizeFeedbackText(context.summary || "");
    if (summary) return summary;
    if (context.editor === "select-3d" && context.pdpOrder) {
      return "Select 3D (`select3d`, imposé par la PDP) — aucun fichier chargé";
    }
    return "non défini — aucun fichier chargé";
  }

  function documentLine(doc) {
    if (!doc) return "aucun fichier chargé dans l'éditeur";
    var width = Math.round(Number(doc.widthMm) * 10) / 10;
    var height = Math.round(Number(doc.heightMm) * 10) / 10;
    var name = sanitizeFeedbackText(doc.sourceName) || "sans nom";
    var count = Number(doc.pathCount) || 0;
    return name + " · " + width + " × " + height + " mm · " + count + " tracé" + (count > 1 ? "s" : "");
  }

  function fileLine(file) {
    if (!file || file.kind === "none") return null;
    var name = sanitizeFeedbackText(file.name) || "fichier";
    if (file.kind === "hosted") return "*Fichier* : " + chatLink(file.url, name);
    return (
      "*Fichier* : ⚠️ « " +
      name +
      " » sélectionné mais non hébergé — " +
      (sanitizeFeedbackText(file.reason) || "raison inconnue") +
      ". Redemander le fichier au client."
    );
  }

  function fitWithinBudget(text, budget) {
    if (budget <= 0) return "";
    if (text.length <= budget) return text;
    if (budget <= TRUNCATION_MARKER.length) return text.slice(0, budget);
    var room = budget - TRUNCATION_MARKER.length;
    var cut = text.slice(0, room);
    var space = cut.lastIndexOf(" ");
    if (space > room - 60) cut = cut.slice(0, space);
    return cut.replace(/\s+$/, "") + TRUNCATION_MARKER;
  }

  function buildFeedbackChatMessage(input) {
    var context = input.context || {};
    var editorLabel = EDITOR_LABELS[context.editor] || context.editor || "éditeur";
    var handle = sanitizeFeedbackText(context.productHandle);
    var lines = [
      "*Aide & idées* · " + editorLabel,
      "",
      "*Éditeur* : " + productTypeLine(context),
      "*Contexte* : " + (context.pdpOrder ? "PDP commande (`pdpOrder`)" : "éditeur autonome"),
      "*Produit* : " + (handle ? "`" + handle + "`" : "handle inconnu"),
      "*Page* : " + chatLink(context.url, "ouvrir la page"),
      "*Client* : " +
        (isValidFeedbackEmail(input.email)
          ? sanitizeFeedbackText(input.email)
          : "email non fourni — réponse impossible"),
    ];
    var file = fileLine(input.file);
    if (file) lines.push(file);
    lines.push("*Document* : " + documentLine(context.document), "", "*Message du client*");
    var head = lines.join("\n") + "\n";
    var comment = sanitizeFeedbackText(input.comment) || "(message vide)";
    var message = head + fitWithinBudget(comment, CHAT_TEXT_LIMIT - head.length);
    return message.length > CHAT_TEXT_LIMIT
      ? message.slice(0, CHAT_TEXT_LIMIT - 1) + "\u2026"
      : message;
  }

  function sendFeedbackToGoogleChat(input) {
    var text = buildFeedbackChatMessage(input);
    return fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: text }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Envoi impossible — Google Chat a répondu " + response.status + ".");
        }
        return { text: text };
      })
      .catch(function (error) {
        var detail = String((error && error.message) || error || "");
        if (/failed to fetch|networkerror|load failed/i.test(detail)) {
          throw new Error("Envoi impossible — connexion interrompue. Réessayez dans un instant.");
        }
        if (/Google Chat a répondu/.test(detail)) throw error;
        throw new Error("Envoi impossible : " + (detail || "erreur inconnue"));
      });
  }

  function guessSummary(editor) {
    try {
      if (editor === "amalgame") {
        var sel = document.getElementById("format-sel");
        var format = sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : "";
        var count = document.querySelectorAll("#canvas .elem").length;
        return [format, count ? count + " élément" + (count > 1 ? "s" : "") : ""]
          .filter(Boolean)
          .join(" · ");
      }
      if (editor === "logo") {
        var logoName = document.querySelector("[data-file-name]");
        return logoName && logoName.textContent ? String(logoName.textContent).trim() : "";
      }
      if (editor === "logo-quality") {
        var lqcName = document.querySelector("[data-file-name]");
        var score = document.querySelector("[data-score-value]");
        return [lqcName && lqcName.textContent, score && score.textContent ? "note " + score.textContent : ""]
          .map(function (bit) {
            return bit ? String(bit).trim() : "";
          })
          .filter(Boolean)
          .join(" · ");
      }
      if (editor === "bat") {
        var title = document.querySelector("[data-project-name], [data-project-textile-name]");
        return title && title.value ? String(title.value).trim() : "";
      }
    } catch (error) {
      return "";
    }
    return "";
  }

  var overlay = null;
  var sending = false;

  function closeModal() {
    if (!overlay) return;
    sending = false;
    try {
      if (typeof overlay.close === "function" && overlay.open) overlay.close();
    } catch (error) {
      /* ignore */
    }
    overlay.remove();
    overlay = null;
    document.removeEventListener("keydown", onEscape, true);
  }

  function onEscape(event) {
    if (event.key !== "Escape") return;
    event.preventDefault();
    event.stopPropagation();
    closeModal();
  }

  function renderForm(options) {
    if (overlay) overlay.remove();
    sending = false;
    overlay = document.createElement("dialog");
    overlay.className = "hf-modal__overlay";
    overlay.setAttribute("aria-labelledby", "hf-help-title");
    overlay.innerHTML =
      '<div class="hf-modal__card">' +
      '<div class="hf-modal__head">' +
      '<h2 id="hf-help-title" class="hf-modal__title">Aide &amp; idées</h2>' +
      '<button type="button" class="hf-modal__close" data-hf-close aria-label="Fermer">×</button>' +
      "</div>" +
      '<p class="hf-modal__subtitle">Aidez-nous à améliorer cet éditeur. Un problème, une idée ? Décrivez-le en quelques mots et joignez le fichier concerné si besoin — nous lisons tout.</p>' +
      '<div data-hf-form>' +
      '<label class="hf-modal__field"><span>Votre e-mail (facultatif)</span>' +
      '<input type="email" autocomplete="email" placeholder="vous@exemple.fr" data-hf-email></label>' +
      '<p class="hf-modal__hint">Sans adresse, nous lisons votre message mais nous ne pouvons pas vous répondre.</p>' +
      '<label class="hf-modal__field"><span>Votre message</span>' +
      '<textarea rows="5" maxlength="' +
      COMMENT_MAX_LENGTH +
      '" placeholder="Ce qui ne marche pas, ce que vous attendiez, ou l\'idée que vous aimeriez voir…" data-hf-comment></textarea></label>' +
      '<label class="hf-modal__field"><span>Fichier concerné (facultatif)</span>' +
      '<input type="file" accept="' +
      FILE_ACCEPT +
      '" data-hf-file></label>' +
      '<p class="hf-modal__hint">Le fichier part vers notre équipe support uniquement : il n\'est pas ajouté à votre commande.</p>' +
      '<p class="hf-modal__error" data-hf-error hidden></p>' +
      "</div>" +
      '<div class="hf-modal__done" data-hf-done hidden role="status"></div>' +
      '<div class="hf-modal__actions"><span class="hf-modal__actions-spacer"></span>' +
      '<button type="button" class="hf-modal__btn" data-hf-cancel>Annuler</button>' +
      '<button type="button" class="hf-modal__btn hf-modal__btn--primary" data-hf-send disabled>Envoyer</button>' +
      "</div></div>";

    var card = overlay.querySelector(".hf-modal__card");
    var emailInput = overlay.querySelector("[data-hf-email]");
    var commentInput = overlay.querySelector("[data-hf-comment]");
    var fileInput = overlay.querySelector("[data-hf-file]");
    var errorEl = overlay.querySelector("[data-hf-error]");
    var formEl = overlay.querySelector("[data-hf-form]");
    var doneEl = overlay.querySelector("[data-hf-done]");
    var cancelBtn = overlay.querySelector("[data-hf-cancel]");
    var closeBtn = overlay.querySelector("[data-hf-close]");
    var sendBtn = overlay.querySelector("[data-hf-send]");
    var pickedFile = null;

    function showError(message) {
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = "";
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function setSending(value) {
      sending = value;
      emailInput.disabled = value;
      commentInput.disabled = value;
      fileInput.disabled = value;
      sendBtn.disabled = value || !String(commentInput.value || "").trim();
      sendBtn.innerHTML = value
        ? '<span class="hf-modal__spinner" aria-hidden="true"></span>Envoi…'
        : "Envoyer";
    }

    overlay.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeModal();
    });
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) closeModal();
    });
    card.addEventListener("click", function (event) {
      event.stopPropagation();
    });
    cancelBtn.addEventListener("click", closeModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    commentInput.addEventListener("input", function () {
      sendBtn.disabled = sending || !String(commentInput.value || "").trim();
    });
    fileInput.addEventListener("change", function () {
      var picked = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
      if (!picked) {
        pickedFile = null;
        return;
      }
      var problem = validateFeedbackFile(picked);
      if (problem) {
        showError(problem);
        pickedFile = null;
        fileInput.value = "";
        return;
      }
      showError("");
      pickedFile = picked;
    });
    sendBtn.addEventListener("click", function () {
      var comment = String(commentInput.value || "");
      var email = String(emailInput.value || "").trim();
      if (sending) return;
      if (!comment.trim()) {
        showError("Décrivez votre problème ou votre idée avant d'envoyer.");
        return;
      }
      if (email && !isValidFeedbackEmail(email)) {
        showError("Cette adresse e-mail semble incorrecte. Corrigez-la ou laissez le champ vide.");
        return;
      }
      setSending(true);
      showError("");
      var fileOutcome = pickedFile
        ? {
            kind: "unhosted",
            name: pickedFile.name,
            reason: "Upload Lift non branché sur cet éditeur",
          }
        : { kind: "none" };
      sendFeedbackToGoogleChat({
        email: email,
        comment: comment,
        file: fileOutcome,
        context: {
          editor: options.editor,
          productType: null,
          productHandle: options.productHandle || productHandleFromLocation(),
          pdpOrder: Boolean(options.pdpOrder),
          url: window.location.href,
          document: null,
          summary: options.summary || guessSummary(options.editor),
        },
      })
        .then(function () {
          formEl.hidden = true;
          sendBtn.hidden = true;
          cancelBtn.textContent = "Fermer";
          doneEl.hidden = false;
          doneEl.innerHTML =
            "<p><strong>Message envoyé, merci !</strong> Notre équipe le lit et vous répond si vous avez laissé votre adresse.</p>" +
            (fileOutcome.kind === "unhosted"
              ? '<p class="hf-modal__warning">Votre message est bien arrivé, mais nous n\'avons pas pu joindre le fichier. Conservez-le : nous vous le demanderons par e-mail si nécessaire.</p>'
              : "");
          setSending(false);
          sending = false;
        })
        .catch(function (error) {
          setSending(false);
          showError(error && error.message ? error.message : "Envoi impossible. Réessayez dans un instant.");
        });
    });

    document.body.appendChild(overlay);
    try {
      if (typeof overlay.showModal === "function") overlay.showModal();
      else overlay.setAttribute("open", "");
    } catch (error) {
      overlay.setAttribute("open", "");
    }
    document.addEventListener("keydown", onEscape, true);
    window.setTimeout(function () {
      emailInput.focus();
    }, 0);
  }

  function open(options) {
    var editor = (options && options.editor) || "amalgame";
    renderForm({
      editor: editor,
      productHandle: (options && options.productHandle) || "",
      pdpOrder: Boolean(options && options.pdpOrder),
      summary: (options && options.summary) || "",
    });
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest("[data-help-feedback]");
    if (!button) return;
    event.preventDefault();
    open({
      editor: button.getAttribute("data-help-editor") || "amalgame",
      productHandle: button.getAttribute("data-help-handle") || "",
      pdpOrder: button.getAttribute("data-help-pdp") === "true",
      summary: button.getAttribute("data-help-summary") || "",
    });
  });

  window.SherpaHelpFeedback = {
    open: open,
    close: closeModal,
  };
})();
